import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebaseconfig';
import { getDoc, doc, setDoc } from 'firebase/firestore';
import AllergenForm from '../../components/AllergenForm';
import '../../views/styles/ProfilePage.css';

function ProfilePage() {
  const [userAllergens, setUserAllergens] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [userInfo, setUserInfo] = useState({ name: '', email: '' }); // Default værdi
  const [isNameEditing, setIsNameEditing] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      if (auth.currentUser) {
        const userDocRef = doc(db, 'users', auth.currentUser.uid);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          setUserAllergens(userData.allergens || []);
          setUserInfo({
            name: userData.name || '', // Hvis navn ikke er gemt
            email: auth.currentUser.email,
          });
        }
      }
    };

    fetchUserData();
  }, []);

  const handleSaveAllergens = async (allergens) => {
    if (auth.currentUser) {
      const userDocRef = doc(db, 'users', auth.currentUser.uid);
      const preferences = {
        allergens,
      };
      try {
        await setDoc(userDocRef, preferences, { merge: true });
        setUserAllergens(allergens);
        setIsEditing(false);
      } catch (error) {
        console.error("Error saving allergens:", error);
      }
    } else {
      console.log("No user is logged in");
    }
  };

  const handleSaveName = async () => {
    if (auth.currentUser && userInfo.name) {
      const userDocRef = doc(db, 'users', auth.currentUser.uid);
      try {
        await setDoc(userDocRef, { name: userInfo.name }, { merge: true });
        setIsNameEditing(false);
      } catch (error) {
        console.error("Error saving name:", error);
      }
    }
  };

  return (
    <div className="profile-page-container">
      <h1 className="profile-page-header">Min Profil</h1>
      {userInfo.email && (
        <div className="user-info">
          {isNameEditing ? (
            <div>
              <input
                type="text"
                value={userInfo.name}
                onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
                placeholder="Udfyld navn"
              />
              <button onClick={handleSaveName}>Gem Navn</button>
            </div>
          ) : (
            <p>
              <strong>Navn:</strong> {userInfo.name || 'Udfyld navn'}
              {!userInfo.name && (
                <button onClick={() => setIsNameEditing(true)}>Rediger Navn</button>
              )}
            </p>
          )}
          <p><strong>Email:</strong> {userInfo.email}</p>
        </div>
      )}
      <button className="button" onClick={() => setIsEditing(true)}>Rediger allergener</button>
      {isEditing || userAllergens.length === 0 ? (
        <AllergenForm
          existingAllergens={userAllergens}
          existingName={userInfo.name} // Sender det eksisterende navn til formen
          onSave={handleSaveAllergens}
        />
      ) : (
        <div>
          <h3 style={{ fontSize: '2rem' }}>Registrerede Allergener:</h3>
          <table className="allergen-table">
            <thead>
              <tr>
                <th>Allergen</th>
              </tr>
            </thead>
            <tbody>
              {userAllergens.map((allergen, idx) => (
                <tr key={idx}>
                  <td>{allergen.da}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <button className="scan-button" onClick={() => navigate('/scan')}>Gå til Scan Side</button>
    </div>
  );
}

export default ProfilePage;